import { gql } from '@apollo/client';

const DYNAMIC_PREVIEW = gql`
  query dynamicTemplate($productId: ID!, $data: [DynamicTemplateFieldValue]) {
    dynamicTemplatePreview(productId: $productId, data: $data)
  }
`;

export { DYNAMIC_PREVIEW };
